<nav>
  <ng-container *ngFor="let topMenuItem of menuItems$ | async">
    <button mat-button [matMenuTriggerFor]="menu">{{ topMenuItem.name }}</button>

    <mat-menu #menu="matMenu" [overlapTrigger]="false">
      <ng-container *ngFor="let item of topMenuItem.children">
        <a *ngIf="item.path" mat-menu-item [routerLink]="item.path">{{ item.name }}</a>
        <a *ngIf="item.externalLink" mat-menu-item [href]="item.externalLink" target="_blank">{{ item.name }}</a>
        <crm-submenu *ngIf="item.children && item.children.length > 0" [menuItems]="item.children">
          {{ item.name }}
        </crm-submenu>
        <mat-divider *ngIf="item.divider"></mat-divider>
      </ng-container>
    </mat-menu>
  </ng-container>
</nav>
